import { handleActions } from 'redux-actions'
import moment from 'moment'
import {
  SET_ROUTE_FORM,
  SET_DEPARTURE_DATE,
  SET_DEPARTURE_ROUTE,
  SET_RETURN_DATE,
  SET_RETURN_ROUTE,
  SET_FORCES_BOOKING,
  SET_IS_COMMERCIAL
} from './constants'
import dateFormats from '../../configuration/dateFormats'

const ferryRouteSelectionInitialState = {
  activeRouteForm: 'RT',
  departureDate: moment().format(dateFormats.default),
  departureRoute: {},
  returnDate: moment()
    .add(1, 'days')
    .format(dateFormats.default),
  returnRoute: {},
  forcesBooking: false,
  isCommercial: false
}

const ferryRouteSelectionReducer = handleActions(
  {
    [SET_ROUTE_FORM]: (state, { payload }) => {
      return {
        ...state,
        activeRouteForm: payload
      }
    },
    [SET_DEPARTURE_DATE]: (state, { payload }) => ({
      ...state,
      departureDate:
        payload && payload.format
          ? payload.format(dateFormats.default)
          : payload
    }),
    [SET_DEPARTURE_ROUTE]: (state, { payload }) => {
      const newDepartureDate = payload.departureDate
        ? moment(payload.departureDate, dateFormats.default)
        : moment().format(dateFormats.default)
      const newReturnDate = payload.returnDate
        ? moment(payload.returnDate, dateFormats.default)
        : moment()
            .add(1, 'days')
            .format(dateFormats.default)
      return {
        ...state,
        departureRoute: payload,
        departureDate: newDepartureDate,
        returnDate: newReturnDate
      }
    },
    [SET_RETURN_DATE]: (state, { payload }) => ({
      ...state,
      returnDate:
        payload && payload.format
          ? payload.format(dateFormats.default)
          : payload
    }),
    [SET_RETURN_ROUTE]: (state, { payload }) => ({
      ...state,
      returnRoute: payload
    }),
    [SET_IS_COMMERCIAL]: (state, { payload }) => ({
      ...state,
      isCommercial: payload
    }),
    [SET_FORCES_BOOKING]: (state, { payload }) => ({
      ...state,
      forcesBooking: payload
    })
  },
  { ...ferryRouteSelectionInitialState }
)

export { ferryRouteSelectionInitialState }
export default ferryRouteSelectionReducer
